import { useState } from 'react';
import { contactSettings as defaultContact } from '../data/contact';

export function useContactSettings() {
  const [contactSettings] = useState(defaultContact);

  return { contactSettings, loading: false };
}

export default useContactSettings;
